import { ReactNode } from 'react';

interface TournamentEmptyProps {
  children?: ReactNode;
}

export default function TournamentEmpty({ children }: TournamentEmptyProps) {
  return (
    <div className='TournamentEmpty'>
      <div className='TournamentEmpty__icon' />
      {children && <p className='TournamentEmpty__text'>{children}</p>}
    </div>
  );
}
